import request from "superagent";
import { getAuthHeader } from "../utils/superagent";
import meta from "src/utils/meta";

export const getZendeskJWTMessaging = async (): Promise<string> => {
  const token = (await getAuthHeader()).Authorization;
  const { text } = await request.get(
    `${meta().jwtMicroserviceBaseUrl}/zendesk/jwt-messaging/${token}`
  );
  return text;
};
